/* Light gearing and chain length calculators on drivetrain product pages, as accordion rows of
   sections/main-product.liquid (the gear_calculator and chain_calculator blocks, rendered by
   snippets/lux-accordions.liquid with snippets/lux-gear-mini-body.liquid and lux-chain-mini-body.liquid).
   Same maths as the full calculators in lux-calculators.js. The gearing row reads this product's tooth
   count from its variants and follows the variant picker; the other side and the tyre come from the
   full calculator's saved gearing (localStorage luxCalcsGear) and go back there once the customer
   changes something. Both rows link to the full calculator with their numbers in the query string. */
(function () {
'use strict';
var PI = Math.PI, IN2M = 0.0254, PITCH = 12.7, GEAR_STORE = 'luxCalcsGear';
var TYRES = [
['20 × 1.50', 19.3], ['20 × 1.60', 19.5], ['20 × 1.75', 19.6], ['20 × 1.85', 20.0], ['20 × 1.95', 20.1], ['20 × 2.10', 20.2],
['20 × 1 1/8 (451)', 20.1], ['20 × 1 3/8 (451)', 20.5], ['OS20 × 1.75 (451 fat)', 21.5], ['20" nominal (chart standard)', 20.0],
['24 × 1.50', 23.3], ['24 × 1.75', 23.6], ['24 × 1.85', 23.9], ['24 × 1 1/8 (520)', 22.8], ['24 × 1 3/8 (520)', 23.2], ['24" nominal (chart standard)', 24.0],
['16 × 1.75 (Micro)', 15.5], ['18 × 1.75 (Mini)', 17.5], ['22 × 2.10', 22.3], ['26 × 2.10', 26.2]
];
function fmt(n, p) { return Number(n).toFixed(p); }
function teethOf(str) {
var s = String(str || '');
var m = /(\d{1,2})\s*T\b/i.exec(s);
if (!m) m = /^\s*(\d{1,2})\s*$/.exec(s);
return m ? Number(m[1]) : NaN;
}
function known(name) { for (var i = 0; i < TYRES.length; i++) if (TYRES[i][0] === name) return true; return false; }
function dia(name) { for (var i = 0; i < TYRES.length; i++) if (TYRES[i][0] === name) return TYRES[i][1]; return 19.6; }
function setResult(box, val, exact) {
if (!box) return;
box.classList.remove('is-empty');
box.querySelector('[data-val]').textContent = val;
var ex = box.querySelector('[data-exact]'); if (ex) ex.textContent = exact || '';
}
function clearResult(box) {
if (!box) return;
box.classList.add('is-empty');
box.querySelector('[data-val]').innerHTML = '&mdash;';
var ex = box.querySelector('[data-exact]'); if (ex) ex.textContent = '';
}
function bind(els, fn) {
els.forEach(function (el) { if (!el) return; el.addEventListener('input', fn); el.addEventListener('change', fn); });
}

/* ---------- gearing ---------- */
function initGear(root) {
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
var role = root.dataset.role === 'front' ? 'front' : 'rear';
var map = {};
try { map = JSON.parse(root.dataset.teethMap || '{}') || {}; } catch (e) { map = {}; }
var form = root.querySelector('[data-mini-form]');
var F = form.elements.front, R = form.elements.rear, T = form.elements.tyre;
var own = role === 'front' ? F : R;
var ownSum = root.querySelector('[data-own-summary]'), ownNote = root.querySelector('[data-own-note]');
var statusEl = root.querySelector('[data-status]'), fullLink = root.querySelector('[data-full-link]');
var res = { gi: root.querySelector('[data-result="gi"]'), ro: root.querySelector('[data-result="ro"]'), ratio: root.querySelector('[data-result="ratio"]') };
TYRES.forEach(function (t) { var o = document.createElement('option'); o.value = t[0]; o.textContent = t[0] + '  ·  ' + t[1].toFixed(1) + '"'; T.appendChild(o); });
var saved = {};
try { saved = JSON.parse(localStorage.getItem(GEAR_STORE) || '{}') || {}; } catch (e) { saved = {}; }
F.value = saved.front > 0 ? saved.front : 44;
R.value = saved.rear > 0 ? saved.rear : 16;
T.value = known(saved.tyre) ? saved.tyre : '20 × 1.75';
function ownTeeth(variantId) {
var t = teethOf(variantId != null ? map[String(variantId)] : '');
if (isNaN(t)) {
var vals = [];
for (var k in map) { var n = teethOf(map[k]); if (!isNaN(n) && vals.indexOf(n) === -1) vals.push(n); }
if (vals.length === 1) t = vals[0];
}
if (isNaN(t)) t = teethOf(root.dataset.title);
return t;
}
function applyOwn(variantId) {
var t = ownTeeth(variantId);
if (!isNaN(t)) {
own.value = t;
ownSum.textContent = t + 'T';
ownNote.hidden = true;
} else {
ownSum.textContent = 'Tooth count not set';
var many = 0; for (var k in map) many++;
ownNote.textContent = many > 1 ? 'Pick a tooth count above, or type it below.' : 'Type its tooth count below.';
ownNote.hidden = false;
}
calc();
}
function updateLink(f, r) {
var base = root.dataset.fullUrl || '';
if (!fullLink || !base) return;
fullLink.href = base + '?front=' + f + '&rear=' + r + '&tyre=' + encodeURIComponent(T.value) + '#gear';
}
function calc() {
var f = parseInt(F.value, 10), r = parseInt(R.value, 10), d = dia(T.value);
if (!(f > 0 && r > 0)) {
clearResult(res.gi); clearResult(res.ro); clearResult(res.ratio);
statusEl.textContent = 'Set both tooth counts to see your gearing.';
statusEl.classList.remove('is-ready');
return;
}
var g = f / r * d, ro = g * PI, ratio = f / r, diff = g - 55;
setResult(res.gi, fmt(g, 1), (diff >= 0 ? '+' : '') + fmt(diff, 1) + '\u2033 vs 44/16 on a 20\u2033');
setResult(res.ro, fmt(ro * IN2M, 2), fmt(ro, 1) + '\u2033 per crank turn');
setResult(res.ratio, fmt(ratio, 2), f + ' / ' + r);
statusEl.textContent = f + ' / ' + r + ' on a ' + T.value + ' tyre.';
statusEl.classList.add('is-ready');
updateLink(f, r);
}
function persist() {
try {
var s = JSON.parse(localStorage.getItem(GEAR_STORE) || '{}') || {};
var f = parseInt(F.value, 10), r = parseInt(R.value, 10);
if (f > 0) s.front = f;
if (r > 0) s.rear = r;
if (known(T.value)) s.tyre = T.value;
localStorage.setItem(GEAR_STORE, JSON.stringify(s));
} catch (e) {}
}
bind([F, R, T], function () { calc(); persist(); });
document.addEventListener('variant:changed', function (e) {
var v = e.detail && e.detail.variant;
if (!v || !(String(v.id) in map)) return;
applyOwn(v.id);
});
applyOwn(root.dataset.variant);
}

/* ---------- chain length ---------- */
function initChain(root) {
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
var form = root.querySelector('[data-mini-form]');
var F = form.elements.front, R = form.elements.rear, CS = form.elements.cs, U = form.elements.unit, T = form.elements.type, LEN = form.elements.len;
var statusEl = root.querySelector('[data-status]'), fullLink = root.querySelector('[data-full-link]');
var res = { links: root.querySelector('[data-result="links"]'), cut: root.querySelector('[data-result="cut"]'), ratio: root.querySelector('[data-result="ratio"]') };
var cutLabel = root.querySelector('[data-cut-label]'), cutUnit = root.querySelector('[data-cut-unit]');
if (root.dataset.half === '1') T.value = 'half';
if (!LEN.value) LEN.value = '112';
function updateLink(f, r, cs) {
var base = root.dataset.fullUrl || '';
if (!fullLink || !base) return;
fullLink.href = base + '?f=' + f + '&r=' + r + '&cs=' + cs + '&unit=' + U.value + '&type=' + T.value + '&len=' + LEN.value + '#chain';
}
function calc() {
var f = parseInt(F.value, 10), r = parseInt(R.value, 10), cs = parseFloat(CS.value);
var newLen = parseInt(LEN.value, 10) || 112, half = T.value === 'half';
cutLabel.textContent = 'Cut from ' + newLen + '-link';
if (!(f > 2 && r > 2 && cs > 0)) {
clearResult(res.links); clearResult(res.cut); clearResult(res.ratio);
statusEl.textContent = 'Enter the sprocket, driver and chainstay to get a link count.';
statusEl.classList.remove('is-ready');
return;
}
var C = U.value === 'in' ? cs * 25.4 : cs;
var rf = PITCH / (2 * Math.sin(PI / f)), rr = PITCH / (2 * Math.sin(PI / r));
var d = rf - rr;
if (Math.abs(d) >= C) {
clearResult(res.links); clearResult(res.cut); clearResult(res.ratio);
statusEl.textContent = 'Chainstay is too short for those sprockets. Check your numbers.';
statusEl.classList.remove('is-ready');
return;
}
var a = Math.asin(d / C);
var L = 2 * Math.sqrt(C * C - d * d) + rf * (PI + 2 * a) + rr * (PI - 2 * a);
var exact = L / PITCH;
var links = half ? Math.ceil(exact - 1e-9) : Math.ceil(exact / 2 - 1e-9) * 2;
var slack = (links - exact) * PITCH / 2;
var rem = newLen - links;
setResult(res.links, links, 'exact ' + fmt(exact, 1) + ' links, ' + fmt(exact * PITCH, 0) + ' mm');
if (rem >= 0) { cutUnit.textContent = rem === 1 ? 'link' : 'links'; setResult(res.cut, rem, rem === 0 ? 'run it as it comes' : 'take ' + rem + ' off'); }
else { cutUnit.textContent = 'short'; setResult(res.cut, -rem, 'pick a longer chain'); }
setResult(res.ratio, fmt(f / r, 2), f + ' / ' + r);
statusEl.textContent = 'Run ' + links + ' links. The axle sits ' + (slack < 0.05 ? 'right on your measurement.' : 'about ' + fmt(slack, 1) + ' mm back from it.') + (half ? '' : ' Standard chains join in pairs, so counts go up in twos.');
statusEl.classList.add('is-ready');
updateLink(f, r, cs);
}
U.addEventListener('change', function () {
var v = parseFloat(CS.value);
if (v > 0) {
if (U.value === 'mm' && CS.dataset.unit !== 'mm') { CS.value = (v * 25.4).toFixed(1); CS.step = '0.5'; }
else if (U.value === 'in' && CS.dataset.unit !== 'in') { CS.value = (v / 25.4).toFixed(2); CS.step = '0.05'; }
}
CS.dataset.unit = U.value;
calc();
});
CS.dataset.unit = U.value;
bind([F, R, CS, T, LEN], calc);
calc();
}

function initAll(scope) {
var s = scope && scope.querySelectorAll ? scope : document;
Array.prototype.forEach.call(s.querySelectorAll('[data-lux-gear-mini]'), initGear);
Array.prototype.forEach.call(s.querySelectorAll('[data-lux-chain-mini]'), initChain);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
else initAll(document);
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
